exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title .title-nav .active a {\n  background: #DC0026;\n  border-radius: 13px;\n  color: #fff !important;\n  padding: 3px 14px;\n}\n", "", {"version":3,"sources":["D:/project/历史版本/pc1210/pc/src/styles/D:/project/历史版本/pc1210/pc/src/styles/D:/project/历史版本/pc1210/pc/src/styles/index.less","D:/project/历史版本/pc1210/pc/src/styles/D:/project/历史版本/pc1210/pc/src/styles/index.less"],"names":[],"mappings":"AACA;EAIQ,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;CCHP","file":"index.less","sourcesContent":["// 导航栏的选中样式\n.title {\n  .title-nav {\n    .active {\n      a {\n        background: #DC0026;\n        border-radius: 13px;\n        color: #fff !important;\n        padding: 3px 14px;\n      }\n    }\n  }\n}\n",".title .title-nav .active a {\n  background: #DC0026;\n  border-radius: 13px;\n  color: #fff !important;\n  padding: 3px 14px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??ref--7-2!./node_modules/less-loader/dist/cjs.js??ref--7-3!./src/styles/index.less
// module id = qIoP
// module chunks = 89